export default [
  {
    path: '/survey/:session',
    name: 'public_survey',
    props: true,
    meta: { title: 'Survey - Innovation Law Lab Platform' },
    component: () => import('@/views/PublicSurvey'),
  },
]
